const ACTION_TYPE = "MEMORIAL-PAGE";
export const UPLOAD_FILE_FAIL = `${ACTION_TYPE}/UPLOAD_FILE_FAIL`;
export const UPLOAD_FILE_SUCCESS = `${ACTION_TYPE}/UPLOAD_FILE_SUCCESS`;

export const DELETE_FILE_FAIL = `${ACTION_TYPE}/DELETE_FILE_FAIL`;
export const DELETE_FILE_SUCCESS = `${ACTION_TYPE}/DELETE_FILE_SUCCESS`;
